import { RoomBaseApiService } from '@/core/service/room.baseapi.service'
import { ErrorWrapper, ResponseWrapper } from '@/core/service/util'

export class RoomCallMixerService extends RoomBaseApiService {
  async changeMixingVideoChannelByUserId(params) {
        // userId, roomGroupId, channel, fromRoomGroupId, fromChannel, callerUserId, targetPageIndex
    try {
      const response = await this.request().post(
        `/api/v3/room/${this.getRoomId()}/call/mixer/changeVideoChannelByUserId`,
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async changeMixingLayoutType(params) {
    try {
        const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/call/mixer/changeLayoutType`,
              {...params, releaseCustomMixingMode: true})
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async changeMixingPage({page}) {
    try {
      const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/call/mixer/changePage`,
          {page})
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async toggleUserMixingVideoByUserId(params) {
    try {
      const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/call/mixer/toggleUserVideo`, params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async addByPassSingleVideo({targetUserId}) {
    try {
      const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/call/mixer/addByPassSingleVideo`, {targetUserId})
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async removeByPassSingleVideo() {
    try {
      const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/call/mixer/removeByPassSingleVideo`)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async changeWallModeTargetScreen(data) {
    try {
      const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/call/mixer/wallModeSetTargetScreen`, data)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}

export const roomCallMixingService = new RoomCallMixerService()
